import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '@/contexts/AppContext';
import AuthLayout from './AuthLayout';
import PasswordInput from './PasswordInput';
import { Loader2 } from 'lucide-react';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAppContext();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await signIn(email, password);
    if (error) setError(error);
    setLoading(false);
  };

  return (
    <AuthLayout>
      <div className="mb-10">
        <h1 className="font-serif text-3xl text-foreground mb-2">Entrar</h1>
        <p className="text-subtle text-sm">Acesse suas Sola Notes e devocionais</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-xs font-medium text-subtle mb-2 uppercase tracking-wider">E-mail</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="seu@email.com"
            className="w-full px-4 py-3.5 rounded-lg bg-background border border-border text-foreground placeholder:text-subtle/50 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
            required
            autoComplete="email"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-subtle mb-2 uppercase tracking-wider">Senha</label>
          <PasswordInput value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
        </div>

        {error && (
          <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20">
            <p className="text-sm text-destructive">{error}</p>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3.5 rounded-lg bg-primary text-primary-foreground font-medium text-sm tracking-wide hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>

      <div className="mt-6 space-y-3 text-center">
        <Link to="/forgot-password" className="block text-sm text-subtle hover:text-foreground transition-colors">
          Esqueci minha senha
        </Link>
        <p className="text-sm text-subtle">
          Não tem conta?{' '}
          <Link to="/signup" className="text-foreground font-medium hover:text-accent transition-colors">
            Criar conta
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
};

export default LoginForm;
